import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { forgetPasswordSendEmail } from './forgetPasswordSendEmail'
import { UnoCaptcha } from 'uno-security-common'

const unoCaptcha = UnoCaptcha.reducer;

const mainReducer = combineReducers({
    form: formReducer,
    forgetPasswordSendEmail,
    unoCaptcha
});

export default mainReducer;